import * as React from 'react';
import { DMDiv, DMText } from '../../../components/Primitives';

interface IssueSummaryChipProps {
  count: number;
  label: string;
  className: string;
}

export const IssueSummaryChip = ({
  count,
  label,
  className,
}: IssueSummaryChipProps) => (
  <DMDiv
    className={`flex h-[5vh] min-w-[7.5vh] flex-col items-center justify-center rounded-[0.72vh] text-center ${className}`}
  >
    <DMText as="span" className="text-[1.68vh] font-bold leading-none">
      {count}
    </DMText>
    <DMText
      as="span"
      className="mt-[0.5vh] text-[1.12vh] font-semibold uppercase leading-none"
    >
      {label}
    </DMText>
  </DMDiv>
);
